<template>
  <ion-page>
    <master-layout pageTitle="اطلاعات حواله مأموریت">
      <Loading :is="!pageLoaded" v-if="!pageLoaded"></Loading>
      <div v-if="pageLoaded">
        <ion-card-content class="mb-1">
            <div v-if="mission">
              <div class="space_between">
                <div>
                  <div class="mb-1">ش مأموریت :
                  {{mission.mission_number}}
                  </div>
                  <div class="mb-1">
                    <i class="far fa-user"></i> :
                    {{customer.fullname}}{{(customer.phone?'('+customer.phone+')':'')}}
                  </div>
                </div>
                <div>
                  <a :href="'tel:'+customer.phone" class="btn btn-success customer_btn"><i class="far fa-phone"></i></a>
                  <a :href="'geo:'+customer.location.coordinates[1]+','+customer.location.coordinates[0]" class="btn btn-info customer_btn"><i class="far fa-directions"></i></a>
                </div>
              </div>
              <div class="">
                وضعیت  :
                {{mission_result}}
              </div>
              <div class="space_between mt-1" v-if="mission.status !== 0">
                <button class="btn btn-success" @click="changeMissionItemStatus(1)">تغییر به تحویل شده</button>
                <button class="btn btn-danger" @click="changeMissionItemStatus(2)">تغییر به برگشت خورده</button>
              </div>
          </div>
        </ion-card-content>
        <ion-card-content class="mt-1">
          <h3>اطلاعات مرسوله :</h3>
          <hr>
          <div>شماره مرسوله : {{sendOrder.order_number}}</div>
          <DataTable card="true" :datas="datas" :headers="headers"></DataTable>
        </ion-card-content>
      </div>
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>
    </master-layout>
  </ion-page>
</template>

<script>
import {alertController, IonCardContent, IonPage} from "@ionic/vue";
import {mapActions} from "vuex";
import AjaxForm from "@/components/AjaxForm";
import Loading from "../../components/Loading";
import DataTable from "../../components/DataTable";
import {showSystemNoti} from "../../shared/helper";


export default {
  name: "missionItemInfo",
  components: {AjaxForm,IonPage,IonCardContent,Loading,DataTable},
  data()
  {
    return {
      id: null,
      pageLoaded: false,
      customer: null,
      mission: null,
      sendOrder : null,
      mission_result : 'درحال ارسال',
      sendOrderItems : [],
      datas : [],
      headers : ['تصویر','عنوان','تعداد'],
      error : false,
    }
  },
  async mounted()
  {
    await this.init();
  },
  methods: {
    ...mapActions('mission',{
      getDeliverMissionItemInfo: 'getDeliverMissionItemInfo',
      changeDeliverMissionItemStatus : 'changeDeliverMissionItemStatus',
      getNoOrderReason: 'getNoOrderReason'
    }),
    async init()
    {
      this.pageLoaded = false;
      this.customer = null;
      this.mission = null;
      this.error = null;
      this.sendOrder = null;
      this.sendOrderItems = [];
      this.id = this.$route.params.id;
      const result = await this.getDeliverMissionItemInfo(this.id);
      if (result)
      {
        if (result.ok)
        {
          const mission_item = result.mission_item;
          if (mission_item.result === 1)
            this.mission_result = 'تحویل شده';
          else if (mission_item.result === 2)
            this.mission_result = 'برگشت خورده';
          this.mission = result.mission;
          this.customer = result.customer;
          this.sendOrder = result.order;
          const order_items = result.order_items;
          this.sendOrderItems = order_items;
          for (let i = 0; i < order_items.length; i++)
          {
            const o = order_items[i];
            let bigger_unit_quantity = o.bigger_unit_quantity;
            let bigger_unit_title = o.bigger_unit_title;
            let bigger_info = '';
            if (bigger_unit_quantity)
            {
              //اینجا باید حساب بشه که داخل واحد بزرکتر چندتا هست
              const q = Number((o.real_quantity / o.bigger_unit_quantity).toFixed(1));
              bigger_info = '<div class="text-danger">('+q + bigger_unit_title+')</div>';
            }

            let img = '<div style="width: 70px;margin: 0 auto;overflow: hidden;">' +
                '<img class="img" src="'+o.thumbnail_url+'" alt="'+o.full_title+'"></div>';
            const quantity = o.real_quantity + ' '+o.small_unit_title+bigger_info;
            this.datas.push([img,o.full_title,quantity]);
          }
          this.pageLoaded = true;
        }
        else
        {
          this.pageLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.pageLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    async changeMissionItemStatus (status)
    {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            message: 'وضعیت حواله تغییر کند.',
            buttons: [
              {
                text: 'لفو',
                role: 'cancel',
                cssClass: 'danger',
                handler: blah =>
                {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'تایید',
                handler: async () =>
                {
                  const check = await this.changeDeliverMissionItemStatus({id : this.id, status});
                  if (check &&check.ok)
                  {
                    if (status === 1)
                      this.mission_result = 'تحویل شده';
                    else if(status === 2)
                        this.mission_result = 'برگشت خورده';
                    return showSystemNoti('success',check.message);
                  }
                  else
                    return showSystemNoti('error',check.error);
                },
              },
            ],
          });
      return alert.present();
    },
  },
  watch : {
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('delivermission/itemid') >= 0 && oldUrl.toLowerCase().indexOf('delivermission/itemid') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
  }
}
</script>

<style scoped>
.space_between
{
  display: flex;
  justify-content: space-between;
}
.mb-1
{
  margin-bottom: 5px;
}
.mr-1
{
  margin-right: 5px;
}
.customer_btn{
  padding: .3rem .7rem .3rem;
  margin-left: 5px;
}
.img
{
  width: 100%;
  height: auto;
}
</style>